import { Link } from "react-router-dom";
function SchoolHall() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active">Sports</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> Sports </h1>
            <p>
              Sports activities in school promote physical fitness, teamwork,
              discipline, and healthy competition by engaging students in a
              variety of games and exercises, helping them build strength,
              coordination, sportsmanship, and a positive attitude toward an
              active lifestyle.
            </p>
          </div>
        </div>
        <br />

        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_1.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_2.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_3.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_4.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_5.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_6.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_7.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_8.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_9.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_10.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_11.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_12.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_13.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_14.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_15.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_16.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_17.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_18.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_19.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            {" "}
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_20.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />{" "}
          </div>
        </div>
      </div>
    </>
  );
}
export default SchoolHall;
